import http from "@/common/http.service";
const SAVE_AUTOMATION_FLOW = "panel/advanced-automation/save/";
const GET_AUTOMATION_DATA = "panel/advanced-automation/details/";
const GET_AUTOMATION_REPORT_DATA = "panel/advanced-automation/report/";
const INACTIVE_AUTOMATION = "panel/advanced-automation/inactivate/";
const INACTIVE_CLASSIC_AUTOMATION = "automation/actions/inactivate/";
const GET_AUTOMATION_DELIVERY_DATA = "advanced-automation/delivery-report/";
const GET_AUTOMATION_CAMPAIGN_WISE_DATA =
  "advanced-automation/campaignwise-report/";
const RENAME_AUTOMATION = "panel/advanced-automation/";
const CAMP_DETAILS = "campaign/campaign_summary";

const SAVE_AUTOMATION_SETTINGS = "panel/advanced-automation/save-settings/";

const PUBLISH_AUTOMATION = "panel/advanced-automation/publish/";
const ACTIVATE_AUTOMATION = "panel/advanced-automation/activate/";
const ACTIVATE_CLASSIC_AUTOMATION = "automation/actions/activate/";
const DELETE_AUTOMATION = "panel/advanced-automation/delete/";
const DELETE_CLASSIC_AUTOMATION = "automation/";
const DUPLICATE_CLASSIC_AUTOMATION = "automation/clone/";

const GET_AUTOMATION_ANALYTICS_DATA = "panel/advanced-automation/report/";

const GET_AUTOMATION_LIST = "panel/advanced-automation/report-list";

export const saveAutomationFlow = (id, params, action) => {
  return http.post(SAVE_AUTOMATION_FLOW + id + "/" + action, params);
};

export const saveAutomationSettings = (id, params) => {
  return http.post(SAVE_AUTOMATION_SETTINGS + id, params);
};

export const getAutomationData = (id) => {
  return http.get(GET_AUTOMATION_DATA + id);
};

export const getAutomationReportData = (id) => {
  return http.get(GET_AUTOMATION_REPORT_DATA + id);
};

export const getAutomationDeliveryData = (id) => {
  return http.get(GET_AUTOMATION_DELIVERY_DATA + id);
};

export const fetchCampaignWiseReport = (id, params) => {
  return http.post(GET_AUTOMATION_CAMPAIGN_WISE_DATA + id, params);
};

export const publishAutomation = (id) => {
  return http.post(PUBLISH_AUTOMATION + id, {});
};

export const activateAutomation = (id) => {
  return http.post(ACTIVATE_AUTOMATION + id, {});
};

export const activateClassicAutomation = (id) => {
  return http.patch(ACTIVATE_CLASSIC_AUTOMATION + id, {});
};

export const deleteAutomation = (id) => {
  return http.deleteRecord(DELETE_AUTOMATION + id);
};

export const deleteClassicAutomation = (id) => {
  return http.deleteRecord(DELETE_CLASSIC_AUTOMATION + id);
};

export const renameAutomation = (id, params) => {
  return http.patch(RENAME_AUTOMATION + id, params);
};

export const disableAutomation = (id, params) => {
  return http.post(INACTIVE_AUTOMATION + id, params);
};

export const disableClassicAutomation = (id, params) => {
  return http.patch(INACTIVE_CLASSIC_AUTOMATION + id, params);
};

export const getCampaignDetails = (id) => {
  return http.post(CAMP_DETAILS, { camp_id: id }).then((response) => {
    return response.data.campaign;
  });
};

export const getAutomationAnalyticalData = (id, type, params) => {
  return http
    .post(GET_AUTOMATION_ANALYTICS_DATA + id + "/" + type, params)
    .then((response) => {
      return response;
    });
};

export const getAutomationActivitiesData = (id, params) => {
  return http.post(GET_AUTOMATION_ANALYTICS_DATA + id + "/activity", params);
};

export const getAutomationAnalyticsGraph = (id, params) => {
  return http.post(GET_AUTOMATION_ANALYTICS_DATA + id + "/day-wise", params);
};

export const markAsPredefined = (automationId, templateId) => {
  return http.post(
    "panel/advanced-automation/template/" +
      templateId +
      "/automation-generate/" +
      automationId,
    {}
  );
};

export const getAutomationList = (params, exportname) => {
  return http.post(GET_AUTOMATION_LIST, params, exportname);
};

export const duplicateAutomation = (id, name) => {
  return http.post(`panel/advanced-automation/duplicate/${id}`, { name });
};

export const duplicateClassicAutomation = (id, name) => {
  return http.post(DUPLICATE_CLASSIC_AUTOMATION + id, { name });
};

export const createAdvancedAutomation = (name) => {
  return http.post("panel/advanced-automation", { name });
};
